import { TabidooTablePage } from '@/components/vyroba/TabidooTablePage';

/** Databáze nití — zrcadlo Tabidoo tabulky „databazeniti". */
export function DatabazeNitiPage() {
  return (
    <TabidooTablePage
      table="niti"
      storagePrefix="niti"
      title="Databáze nití"
      subtitle="Zrcadlo z Tabidoo. Hledej globálně, filtruj po sloupcích, přehazuj sloupce tažením. Klikni na řádek pro detail a editaci."
      createLabel="Nová nit"
    />
  );
}
